<template>
  <v-container style="height: 100%"  v-if="$route.name === 'ListArchivedApplications'">

    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Аттестационные архивные дела соискателей:</span>
        <v-spacer></v-spacer>
        <v-text-field
          class="pa-1 ma-1"
          label="Фамилия"
          v-model="lastName"
        >
        </v-text-field>
        <v-text-field
          class="pa-1 ma-1"
          label="Имя"
          v-model="firstName"
        >
        </v-text-field>
        <v-text-field
          class="pa-1 ma-1"
          label="Отчество"
          v-model="patronymic"
        >
        </v-text-field>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="getItemsClear" color="primary" icon flat><v-icon>clear</v-icon></v-btn>
          </template>
          <span>Очистить поля ввода</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="getItems" color="primary" icon flat><v-icon>search</v-icon></v-btn>
          </template>
          <span>Поиск</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text class="pb-3 pt-1">
        <v-layout justify-center>
          <v-flex>
            <v-data-table
              :headers="headers"
              :items="items"
              :pagination.sync="pagination"
              :total-items="total"
              :loading="loading"
              class="elevation-1"
              :rows-per-page-items="[10,15,100]"
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props">
                <tr class="justify-center"  @click="goPath(props.item)"  style="cursor:pointer">
                  <td class="justify-center">
                    <div  v-for="item, i in props.item.lastName">
                      {{item.text}}
                    </div>
                  </td>
                  <td class="justify-center">
                    <div  v-for="item, i in props.item.firstName">
                      {{item.text}}
                    </div>
                  </td>
                  <td class="justify-center">
                    <div  v-for="item, i in props.item.patronymic">
                      {{item.text}}
                    </div>
                  </td>
                  <td class="justify-center">
                    <div  v-for="item, i in props.item.thesisTopic">
                      {{item.text}}
                    </div>
                  </td>
                  <td class="justify-center">
                    <div  v-for="item, i in props.item.academicDegree.name">
                      {{item.text}}
                    </div>
                  </td>
                  <td class="justify-center">{{props.item.dissertationCouncil.code}} </td>
                  <td class="justify-center"><div v-if="selectors.status.length > 0">{{selectors.status[props.item.status.status].text}}</div>  </td>
                  <td class="justify-center"><div v-if="selectors.status.length > 0">{{ displayDate(props.item.status.setDate,true)}}</div>  </td>
                </tr>

              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>

          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

  </v-container>
  <div v-else>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>


<script>

    import urls from "../../../../modules/petition/urls"
    import UserDataMixin from '../../../../mixins/UserDataMixin'
    import {makeGetRequest} from "../../../../helper";
    import moment from "moment"

    export default {
        name: "ListArchivedApplications",
        mixins: [UserDataMixin],
        data () {
            return {
                URL_LIST: urls.getUrl('admin|case|models|candidate_case-list', 'list')+"?status_stage=Not_ACTIVE",
                URL_DELETE: urls.getUrl('admin|case|models|candidate_case-detail', 'destroy'),
                selectors:{
                    status:[],
                },
                lastName: "",
                firstName: "",
                patronymic: "",
                total: 0,
                items: [],
                loading: true,
                pagination: {},
                headers: [
                    {text: 'Фамилия', sortable: true, align: 'justify-center', value: 'lastName',width: '10%'},
                    {text: 'Имя', sortable: true, align: 'justify-center', value: 'firstName',width: '10%'},
                    {text: 'Отчество', sortable: true, align: 'justify-center', value: 'patronymic',width: '10%'},
                    {text: 'Тема', sortable: true, align: 'justify-center', value: 'thesisTopic',width: '25%'},
                    {text: 'Ученая степень', sortable: true, align: 'justify-center', value: 'academicRank',width: '5%'},
                    {text: 'Диссовет', sortable: true, align: 'justify-center', value: 'dissertationCouncil',width: '5%'},
                    {text: 'Статус', sortable: true, align: 'justify-center', value: 'status',width: '5%'},
                    {text: 'Дата статуса', sortable: true, align: 'justify-center', value: 'setDate',width: '5%'},
                ]
            }
        },
        watch: {
            pagination: {
                handler () {
                    this.getItems()
                },
                deep: true
            }
        },
        mounted () {
            this.$store.commit('mainpage/changeTitle', 'Заявки в архиве');
            this.loadSelector("status",process.env.VUE_APP_API_HOST + "council/admin/case/choices/status_choices/")
        },
        methods: {
            getItemsClear(){
                this.lastName = "";
                this.firstName = "";
                this.patronymic = "";
                this.getItems()
            },
            //Вывод даты
            displayDate: function (date, minutes = false) {
                let format = 'DD.MM.YYYY'
                if (minutes)
                    format += ' HH:mm'
                return moment(date).format(format)
            },
            loadSelector(data, url) {
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.selectors[data] = json
                })
            },
            goPath(item){
              let paramR = {id: item.id}
              if(this.$route.params.token){
                paramR = {token:this.$route.params.token,id: item.id}
              }
                this.$router.push({name:'ArchivedApplication', params: paramR})
            },
            addItem(){
                this.closedForm()
                this.getItems();
            },
            getItems () {
                this.$store.commit('mainpage/changeTitle', 'Заявки в работе');
                this.loading = true
                let url = new URL(this.URL_LIST)
                let params = {};
                if(this.pagination.page !== undefined) {
                    params.page = this.pagination.page;
                    params.page_size = this.pagination.rowsPerPage;
                }
                else{
                    params.page = "1";
                    params.page_size = "10";
                }
                params.status_stage='NOT_ACTIVE'
                if(this.lastName.length !== 0)
                    params.lastName__icontains = this.lastName
                if(this.firstName.length !== 0)
                    params.firstName__icontains = this.firstName
                if(this.patronymic.length !== 0)
                params.patronymic__icontains = this.patronymic
                url.search = new URLSearchParams(params).toString();
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }) .then(json => {
                    this.items = json.results
                    this.total = json.count
                    this.loading = false
                })
            },
        }
    }


</script>
<style scoped>

</style>
